import jwtDecode from 'jwt-decode'
import { useAuthorizationStore } from '../store/useAuthStore'

export function revalidateAuth() {
  if (!checkTokenValidity()) {
    useAuthorizationStore.setState((store: any) => ({ ...store, isAuthenticated: false }))
  }
}

export function checkTokenValidity() {
  const CLOCK_SKEW_MARGIN = 1000 * 60 * 5
  const token = sessionStorage.getItem('accessToken')
  if (!token) return true
  const decodedToken = decodeAuthToken(token)
  const currentDate = new Date()
  if (decodedToken.exp * 1000 - currentDate.getTime() < CLOCK_SKEW_MARGIN) return false
  return true
}

export function decodeAuthToken(accesstoken: string) {
  const decodedToken = jwtDecode(accesstoken) as {
    xUserToken: string
    exp: number
    id: string
    role: string
    fullName: string
    emailId: string
  }
  return decodedToken
}

export function useClearCredentials() {
  const userAuthStore = useAuthorizationStore()
  const credentialKeys = ['accessToken']
  credentialKeys.forEach((key) => {
    sessionStorage.removeItem(key)
  })
  userAuthStore.clearAuthorization()
}
